import { render, staticRenderFns } from "./TermsPreamble.vue?vue&type=template&id=43c18357&scoped=true"
import script from "./TermsPreamble.vue?vue&type=script&lang=ts"
export * from "./TermsPreamble.vue?vue&type=script&lang=ts"
import style0 from "./TermsPreamble.vue?vue&type=style&index=0&id=43c18357&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c18357",
  null
  
)

export default component.exports